/* Ready2Talk — Quick Add-to-Cart & Sticky ATC helpers */
(function () {
  'use strict';

  /* ---- Quick ATC on product card (icon-only button, uses CSS classes for state) ---- */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-r2t-quick-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variant;
    if (!variantId || btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;

    btn.classList.add('is-loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error('failed');

      btn.classList.remove('is-loading');
      btn.classList.add('is-done');

      // Dispatch Horizon's cart:update event — cart-icon.js handles bubble
      // visibility, count text, and the bump animation.
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'r2t-quick-atc',
              data: { itemCount: cart.item_count, source: 'r2t-quick-atc' }
            }
          }));
        });

      setTimeout(() => {
        btn.classList.remove('is-done');
      }, 1800);
    } catch {
      btn.classList.remove('is-loading');
      setTimeout(() => {}, 1200);
    }
  });

  /* ---- Sticky Add-to-Cart bar on product pages ---- */
  const stickyBar = document.querySelector('.r2t-sticky-atc');
  const mainAtcBtn = document.querySelector('[data-r2t-atc]');
  if (stickyBar && mainAtcBtn) {
    const stickyAtcBtn = stickyBar.querySelector('.r2t-sticky-atc__btn');

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const hide = entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', !hide);
          // `inert` both hides from the a11y tree AND prevents Tab focus on
          // descendants — fixes "[aria-hidden=true] contains focusable elements"
          // (was caused by toggling aria-hidden alone while the button stayed tabbable).
          if (hide) {
            stickyBar.setAttribute('inert', '');
          } else {
            stickyBar.removeAttribute('inert');
          }
        });
      },
      { threshold: 0, rootMargin: '-60px 0px 0px 0px' }
    );
    obs.observe(mainAtcBtn);

    stickyAtcBtn?.addEventListener('click', () => {
      mainAtcBtn.click();
    });

    const priceEl = document.querySelector('[data-r2t-price]');
    const stickyPriceEl = stickyBar.querySelector('.r2t-sticky-atc__price');
    if (priceEl && stickyPriceEl) {
      new MutationObserver(() => {
        stickyPriceEl.textContent = priceEl.textContent;
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  }
})();
